import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TeamsMainComponent} from './../../teams/teams-main/teams-main.component';

@Component({
  selector: 'people-teams-wrapper',
  standalone: true,
  imports: [TeamsMainComponent],
  templateUrl: './people-teams-wrapper.component.html',
  styleUrl: './people-teams-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleTeamsWrapperComponent {}
